import { required } from 'vuelidate/lib/validators'

export default {
    validations: {
        user: {
            first_name: {
                required,
            },
            // last_name: {
            //     required,
            // },
            birthdate: {
                required,
            },
            tax_number: {
                required,
            },
            street: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            zip_code: {
                required,
            },
        },
    },

    computed: {
        firstNameErrors() {
            let errors = ''

            if (!this.$v.user.first_name.$dirty) {
                return errors
            }

            if (!this.$v.user.first_name.required)
                errors = errors.concat(this.$t('validations.name_is_required'))

            return errors
        },

        // lastNameErrors() {
        //     let errors = ''

        //     if (!this.$v.user.last_name.$dirty) {
        //         return errors
        //     }

        //     if (!this.$v.user.last_name.required)
        //         errors = errors.concat(
        //             this.$t('validations.last_name_is_required')
        //         )

        //     return errors
        // },

        birthDateErrors() {
            let errors = ''

            if (!this.$v.user.birthdate.$dirty) {
                return errors
            }

            if (!this.$v.user.birthdate.required)
                errors = errors.concat(
                    this.$t('validations.birthdate_is_required')
                )

            return errors
        },

        taxNumberErrors() {
            let errors = ''

            if (!this.$v.user.tax_number.$dirty) {
                return errors
            }

            if (!this.$v.user.tax_number.required)
                errors = errors.concat(
                    this.$t('validations.tax_number_is_required')
                )

            return errors
        },

        streetErrors() {
            let errors = ''

            if (!this.$v.user.street.$dirty) {
                return errors
            }

            if (!this.$v.user.street.required)
                errors = errors.concat(
                    this.$t('validations.street_is_required')
                )

            return errors
        },

        cityErrors() {
            let errors = ''

            if (!this.$v.user.city.$dirty) {
                return errors
            }

            if (!this.$v.user.city.required)
                errors = errors.concat(this.$t('validations.city_is_required'))

            return errors
        },

        stateErrors() {
            let errors = ''

            if (!this.$v.user.state.$dirty) {
                return errors
            }

            if (!this.$v.user.state.required)
                errors = errors.concat(this.$t('validations.state_is_required'))

            return errors
        },

        zipCodeErrors() {
            let errors = ''

            if (!this.$v.user.zip_code.$dirty) {
                return errors
            }

            if (!this.$v.user.zip_code.required)
                errors = errors.concat(
                    this.$t('validations.zipcode_is_required')
                )

            return errors
        },
    },
}
